import React, { Component } from "react"
import { isValidPhoneNumber } from "react-phone-number-input"
import * as endpoint from "../../booking/constants/Endpoints"
import axios from "axios"
import Spinner from "../../booking/components/spinner"
import Emitter from "../../helpers/emitter"
import * as emits from "../../constants/emits"

export default class PhoneNumberValidationField extends Component {
  constructor(props) {
    super(props)

    this.state = {
      phoneNumber: props.profile?.ContactDetails?.MobilePhone,
      isValid: true,
      profile: props.profile,
      mobilePhoneVerified: props.profile?.ContactDetails?.MobilePhoneVerified,
      verficationCodeSent: undefined,
      smsCodeValid: true,
      smsCode: undefined,
      hosts: document.body && document.body.dataset.hosts && JSON.parse(document.body.dataset.hosts),
      ajaxSpinnerActive: false,
      ajaxSpinnerTransparent: false,
      textKeys: props.textKeys,
    }
  }

  validatePhoneNumber = (phoneNumber) => {
    return isValidPhoneNumber(phoneNumber)
  }

  handlePhoneSubmit = () => {
    if (this.state.isValid) {
      this.setState({ ajaxSpinnerActive: true })
      const url = endpoint.UPDATE_PHONE(this.state.hosts, this.state.phoneNumber)
      axios
        .post(url)
        .then((res) => {
          this.setState({ verficationCodeSent: res.data.item1 })
          if (!res.data.item1) {
            // res.data.item2 is exception from endpoint
            throw this.state.textKeys?.phoneVerificationErrorHeadline || "Der skete en fejl.."
          }
        })
        .catch((error) => {
          this.setState({
            error,
            verficationCodeSent: false,
          })
          Emitter.emit("*", {
            type: emits.REQUEST_CONTENT_MODAL_OPEN,
            modalJson: {
              usePortalStyling: true,
              h3: error || "Der skete en fejl..",
              richText: this.state.textKeys?.phoneVerificationErrorMessage || "<p>Der skete en fejl med verificeringen af dit mobilnummer</p>",
            },
          })
        })
        .finally(() => {
          this.setState({ ajaxSpinnerActive: false })
        })
    }
  }

  handleCodeSubmit = () => {
    if (this.state.smsCode.length !== 6) {
      this.setState({ smsCodeValid: false })
    } else {
      this.setState({ ajaxSpinnerActive: true })
      const url = endpoint.VERIFY_PHONE(this.state.hosts, this.state.smsCode)
      axios
        .post(url)
        .then((res) => {
          this.setState({ smsCodeValid: res.data.item1, mobilePhoneVerified: res.data.item1 })
          if (!res.data.item1) {
            // res.data.item2 is exception from endpoint
            throw this.state.textKeys?.smsCodeVerificationErrorHeadline || "Der skete en fejl.."
          }
        })
        .catch((error) => {
          this.setState({
            error,
            smsCodeValid: false,
            mobilePhoneVerified: false,
          })
          Emitter.emit("*", {
            type: emits.REQUEST_CONTENT_MODAL_OPEN,
            modalJson: {
              usePortalStyling: true,
              h3: error || "Der skete en fejl..",
              richText: this.state.textKeys?.smsCodeVerificationErrorMessage || "<p>Der skete en fejl med verificeringen af din SMS kode</p>",
            },
          })
        })
        .finally(() => {
          this.setState({ ajaxSpinnerActive: false })
        })
    }
  }

  changePhoneNumberClick = () => {
    this.setState({ verficationCodeSent: false, smsCodeValid: true })
  }

  render() {
    const { textKeys } = this.props
    const codeSent =
      textKeys?.smsCodeSentMessage.replace("{phone}", this.state.phoneNumber) || `Vi har sendt en SMS kode til ${this.state.phoneNumber}`
    const phoneValidated =
      textKeys?.verifiedPhoneMessage.replace("{phone}", this.state.phoneNumber) ||
      `Telefon ${this.state.phoneNumber} valideret. Ret telefonnummer på `
    return !this.state.mobilePhoneVerified ? (
      <React.Fragment>
        <Spinner isActive={this.state.ajaxSpinnerActive} isTransparent={this.state.ajaxSpinnerTransparent} />
        {!this.state.verficationCodeSent ? (
          <React.Fragment>
            <div
              className={`form__field form__field--text is-filled ${
                this.state.isValid && this.state.phoneNumber ? "is-valid" : this.state.isValid ? "" : "is-invalid"
              } is-bound`}
            >
              <span className="form__valid"></span>
              <input
                className="form__item "
                type="text"
                value={this.state.phoneNumber ? this.state.phoneNumber : ""}
                placeholder={this.props.placeholder}
                onChange={(e) => this.setState({ phoneNumber: e.target.value, isValid: this.validatePhoneNumber(e.target.value) })}
              />
              <label className="form__label">
                <span className="form__label__text">
                  {textKeys?.phoneNumberLabel || "Telefonnummer"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                </span>
              </label>
              <span className={`form__notice ${this.state.isValid && this.state.phoneNumber ? "form__notice--box" : ""}`}>
                {this.state.isValid && this.state.phoneNumber
                  ? textKeys?.validPhoneMessage || "Telefonnummeret er korrekt, bekræft med SMS kode"
                  : this.state.isValid
                    ? textKeys?.inputPhoneMessage || "Skriv mobilnummer med landekode og valider vis SMS"
                    : textKeys?.invalidPhoneMessage || "Ugyldigt mobilnummer, husk landekode"}
              </span>
            </div>
            {this.state.isValid && this.state.phoneNumber ? (
              <div className={"cta-button"}>
                <a className="button button--small button--general" onClick={() => this.handlePhoneSubmit()}>
                  <span className="text">{textKeys?.confirmButton || "Send SMS"}</span>
                </a>
              </div>
            ) : (
              ""
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className={`form__field`}>
              <p>
                {codeSent} -{" "}
                <a className={"link-style"} onClick={() => this.changePhoneNumberClick()}>
                  {textKeys?.editNumberLabel || "Ret Telefonnummer"}
                </a>
              </p>
            </div>
            <div
              className={`form__field form__field--text is-filled ${
                this.state.smsCodeValid && this.state.smsCode ? "is-valid" : this.state.smsCodeValid ? "" : "is-invalid"
              } is-bound`}
            >
              <span className="form__valid"></span>
              <input className="form__item " type="text" placeholder={"123456"} onChange={(e) => this.setState({ smsCode: e.target.value })} />
              <label className="form__label">
                <span className="form__label__text">
                  {textKeys?.smsCodeLabel || "SMS Kode"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                </span>
              </label>
              {!this.state.smsCodeValid ? (
                <span className={`form__notice form__notice--box`}>{textKeys?.smsCodeWrongMessage || "FORKERT SMS KODE"}</span>
              ) : (
                ""
              )}
            </div>
            <div className={"cta-button"}>
              <a className="button button--small button--general" onClick={() => this.handleCodeSubmit()}>
                <span className="text">{textKeys?.confirmSMSCodeLabel || "Bekræft"}</span>
              </a>
              &nbsp;
              {!this.state.smsCodeValid ? (
                <a className="button button--small button--general" onClick={() => this.handlePhoneSubmit()}>
                  <span className="text">{textKeys?.sendNewSMS || "Send ny SMS"}</span>
                </a>
              ) : (
                ""
              )}
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    ) : (
      <React.Fragment>
        <div className={`form__field`}>
          <p>
            {phoneValidated}
            <a className={"link-style"} href={textKeys?.profilePageLink || "/min-side/profilside"}>
              {textKeys?.profilePageLabel || "min profilside"}
            </a>
          </p>
        </div>
      </React.Fragment>
    )
  }
}
